import { Action } from '@ngrx/store';
import {ConnectWifiParams, WifiCardInfo, WifiList} from '../../../models/devices';

export enum BindWifiCardActionTypes {
  GetBindWifiCards = '[BindWifiCard] Get BindWifiCards',
  LoadBindWifiCards = '[BindWifiCard] Load BindWifiCards',
  GetBindWifiCardsFail = '[BindWifiCard] Get BindWifiCards Fail',
  GetWifiList = '[BindWifiCard] Get WifiList',
  LoadWifiList = '[BindWifiCard] Load WifiList',
  GetWifiListFail = '[BindWifiCard] Get WifiList Fail',
  GetConnectWifi = '[BindWifiCard] Get ConnectWifi',
  LoadConnectWifiResult = '[BindWifiCard] Load ConnectWifiResult',
  GetConfigWifiCardResult = '[BindWifiCard] Get ConfigWifiCardResult',
  LoadConfigWifiCardResult = '[BindWifiCard] Load ConfigWifiCardResult',
  ChangStepWifiCards = '[BindWifiCard] Change StepWifiCards',
}


export class GetBindWifiCards implements Action {
  readonly type = BindWifiCardActionTypes.GetBindWifiCards;
}

export class LoadBindWifiCards implements Action {
  readonly type = BindWifiCardActionTypes.LoadBindWifiCards;
  constructor(public payload: WifiCardInfo) {}
}

export class GetBindWifiCardsFail implements Action {
  readonly type = BindWifiCardActionTypes.GetBindWifiCardsFail;
}

export class GetWifiList implements Action {
  readonly type = BindWifiCardActionTypes.GetWifiList;
}

export class LoadWifiList implements Action {
  readonly type = BindWifiCardActionTypes.LoadWifiList;
  constructor(public payload: WifiList[]) {}
}

export class GetWifiListFail implements Action {
  readonly type = BindWifiCardActionTypes.GetWifiListFail;
}

export class GetConnectWifi implements Action {
  readonly type = BindWifiCardActionTypes.GetConnectWifi;
  constructor(public payload: ConnectWifiParams) {}
}

export class LoadConnectWifiResult implements Action {
  readonly type = BindWifiCardActionTypes.LoadConnectWifiResult;
}

export class GetConfigWifiCardResult implements Action {
  readonly type = BindWifiCardActionTypes.GetConfigWifiCardResult;
}

export class LoadConfigWifiCardResult implements Action {
  readonly type = BindWifiCardActionTypes.LoadConfigWifiCardResult;
}

export class ChangStepWifiCards implements Action {
  readonly type = BindWifiCardActionTypes.ChangStepWifiCards;
  constructor(public payload: number) {}
}



export type BindWifiCardActions = LoadBindWifiCards
  | GetBindWifiCards
  | GetWifiList
  | LoadWifiList
  | GetWifiListFail
  | GetConnectWifi
  | LoadConnectWifiResult
  | GetConfigWifiCardResult
  | LoadConfigWifiCardResult
  | ChangStepWifiCards
  | GetBindWifiCardsFail;
